import React, { useState, useEffect, useContext, useMemo } from 'react';


import SimpleTable from '../../components/tables/simpleTable';

import RecoverModal from '../../components/modals/recoverModal';
import VoidModal from '../../components/modals/voidModal';
import ViewModal from '../../components/modals/viewModal';
import CashTransferForm from './cashTransferForm';

import SearchFilter from '../../components/filters/search';
import CustomButton from '../../components/buttons/customButton';
import IsActiveFilter from '../../components/filters/isActive';
import AddButton from '../../components/buttons/addButton';
import DataFilter from '../../components/filters/dataFilter';
import DatePicker from '../../components/filters/datePicker';
import { selectStyles } from '../../components/dropDown/selectStyle';

import { FiRotateCcw, FiPrinter, FiFilter } from "react-icons/fi";

import { FcViewDetails } from "react-icons/fc";

import Loader from '../../components/loader/loader';
import { numberFormatter, totalFormatter, decimalFormatter } from '../../components/formatters/numberFormatter';
import { dateFormatter } from '../../dynamic/dateFormatter';
import { typeFormatter, paymentTypeFormatter, statusFormatter, statusTextFormatter } from '../../components/formatters/defFormatter';
import { dateTableFormatter } from '../../dynamic/dateFormatter';
import toast from 'react-hot-toast';
import { Space, Input, Tag, Button, Spin, Modal, Card } from 'antd';

import Select from 'react-select';
import AsyncSelect from 'react-select/async';

import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";

import { DataContext } from '../../init/getData';




function CashTransfer(props) {

  const { api, userData, settingData, devData, yearId, companyId, allUserOptions, branchId, branchOptions,
    mainCurrency, secondaryCurrency, formLanguages, contentLanguages } = useContext(DataContext);
  const userRole = userData.role;
  const [loadingCounter, setLoadingCounter] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isSpinning, setIsSpinning] = useState(false);
  const [data, setData] = useState([]);
  const createdBy = parseInt(userData.id);
  const roundTo = settingData.roundTo;


  const type = 'CashTransfer';
  const isDebit = true;

  const table = 'journalVoucher';
  const title = type;


  const today = new Date().toISOString().split('T')[0];

  const [idRow, setIdRow] = useState([]);
  const [refreshTable, setRefreshTable] = useState(true);
  const [columnDefs, setColumnDefs] = useState([]);
  const [filter, setFilter] = useState({ search: '', isActive: 'true', fromDate: today, toDate: today, type: ['CashTransfer'], companyId, yearId });


  const [showViewModal, setShowViewModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showRecoverModal, setShowRecoverModal] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const selectedBranch = useMemo(() => {
    if (!userRole.viewAllBranches) {
      setFilter((prev) => ({ ...prev, branchId: branchId }));
      return branchOptions?.find(option => option.value === branchId);
    }
    return branchOptions?.find(option => option.value === filter.branchId);
  }, [userRole.viewAllUsers, filter.branchId]);


  const selectedUser = useMemo(() => {
    if (!userRole.viewAllUsers) {
      setFilter((prev) => ({ ...prev, createdBy: createdBy }));
      return allUserOptions?.find(option => option.value === createdBy);
    }
    return allUserOptions?.find(option => option.value === filter.createdBy);
  }, [allUserOptions, filter.createdBy]);

  const handleSelectChange = (selectedOption, name) => {
    setFilter((prev) => ({
      ...prev,
      [name]: selectedOption?.value,
    }));
  }

  const recoverModal = (e) => {
    if (!showRecoverModal) {
      setIdRow(e);
    }
    setShowRecoverModal(!showRecoverModal);
  }

  const deleteModal = (e) => {
    if (!showDeleteModal) {
      setIdRow(e);
    }
    setShowDeleteModal(!showDeleteModal);
  }

  const viewModal = (e) => {
    if (!showViewModal) {
      setIdRow(e);
    }
    setShowViewModal(!showViewModal);
  }

  const openModal = (e) => {
    if (!showModal && e) {
      setIdRow(e);
    }
    else {
      setIdRow(null);
    }
    setShowModal(!showModal);
  }



  const refreshTableFunction = () => {
    setRefreshTable(!refreshTable)
  }

  //Excel Data
  const getExcelData = (data) => {

    const transformedData = [];
    data.forEach(item => {

      const newItem = {
        id: item.id,
        refNumber: item.refNumber,
        date: item.createdAt,
        paymentType: item.paymentType,
        account: item.account?.english || item.account?.name,
        currency: item.currency?.code || 'N/A',
        Total: item.debit,
        [mainCurrency?.code || 'MainCurrency']: item.totalDebit,
        [secondaryCurrency?.code || 'SecondaryCurrency']: item.secondaryTotalDebit,
        details: item.details,
        status: statusTextFormatter(item.status),
      };

      transformedData.push(newItem);
    });

    return { transformedData };
  };

  let newColumnDefs = [
    { title: contentLanguages.ID, dataIndex: 'id', width: '6%', sorter: (a, b) => a.age - b.age },
    { title: contentLanguages.Ref, dataIndex: 'refNumber', width: '6%' },
    { title: contentLanguages.Date, dataIndex: 'date', width: '8%' },
    { title: contentLanguages.Account, dataIndex: 'account', render: (account) => (account?.english), width: '10%' },
    { title: contentLanguages.ToAccount, dataIndex: 'secondaryAccount', render: (account) => (account?.english), width: '10%' },
    { title: contentLanguages.Currency, dataIndex: 'currency', render: (currency) => (currency?.code), width: '8%' },
    { title: contentLanguages.Total, dataIndex: 'debit', render: numberFormatter },
    { title: mainCurrency?.code, dataIndex: 'totalDebit', render: numberFormatter },
    { title: secondaryCurrency?.code, dataIndex: 'secondaryTotalDebit', render: numberFormatter },
    { title: contentLanguages.Details, dataIndex: 'details', width: '10%' },
    { title: contentLanguages.Status, dataIndex: 'status', render: statusFormatter },
  ];

  useEffect(() => {

    newColumnDefs.push(
      {
        title: contentLanguages.View,
        width: '5%',
        render: (_, record) => (
          <FcViewDetails size={18} style={{ cursor: 'pointer', color: '#2E70A5' }} onClick={() => viewModal(record)} />
        ),
      },
      {
        title: contentLanguages.Edt,
        width: '5%',
        render: (_, record) => (
          <FiEdit size={16} style={{ cursor: 'pointer', color: '#2E70A5' }} onClick={() => openModal(record)} />
        ),
      },
      {
        title: contentLanguages.Void,
        width: '5%',
        render: (_, record) => (record.isActive ? (
          <BiSolidTrash size={18} style={{ cursor: 'pointer', color: '#e6434f' }} onClick={() => deleteModal(record)} />
        ) : <FcUndo size={18} style={{ cursor: 'pointer', color: '#e6434f' }} onClick={() => recoverModal(record)} />
        )
      }
    );

    setColumnDefs(newColumnDefs);

  }, []);


  const tableFooter = (
    <div></div>
  )

  return (
    <div>

      {isLoading &&
        <Loader />
      }


      {!isLoading &&
        <div>
          <Row className='g-2 mb-3'>

            <Col md={2}>
              <SearchFilter setFilter={setFilter} />
            </Col>

            <Col md={3}>
              <DatePicker setFilter={setFilter} filter={filter} />
            </Col>

            <Col md={2}>
              <Select
                styles={selectStyles}
                options={branchOptions}
                isSearchable={true}
                isClearable={true}
                required
                placeholder={'Select Branch...'}
                value={selectedBranch}
                onChange={(e) => handleSelectChange(e, 'branchId')}
                isDisabled={!userRole.viewAllBranches}
              />
            </Col>


            <Col md={2}>
              <Select
                styles={selectStyles}
                options={allUserOptions}
                isSearchable={true}
                isClearable={true}
                required
                placeholder={'Select User...'}
                value={selectedUser}
                onChange={(e) => handleSelectChange(e, 'createdBy')}
                isDisabled={!userRole.viewAllUsers}
              />
            </Col>


            <Col md={1}>
              <Button onClick={refreshTableFunction} style={{ backgroundColor: '#22566a' }}>
                <FiFilter size={15} color='white' />
              </Button>
            </Col>

            <Col md={2} className="d-flex justify-content-end">
              <Button onClick={refreshTableFunction}>
                <FiPrinter size={18} />
              </Button>
              <Button onClick={refreshTableFunction}>
                <FiRotateCcw size={18} />
              </Button>
              <Button
                style={{ backgroundColor: '#23576a', color: 'white' }}
                onClick={() => openModal()} >{formLanguages.Add}</Button>
            </Col>

          </Row>

          <SimpleTable
            filter={filter}
            showAddModal={showModal}
            table={table}
            title={title}
            columnDefs={columnDefs}
            idRow={idRow}
            setIdRow={setIdRow}
            refreshTable={refreshTable}
            data={data}
            setData={setData}
            tableFooter={tableFooter}
            api={api}
            getExcelData={getExcelData}
            selection={true}
          />


          <ViewModal
            showModal={showViewModal}
            toggleModal={viewModal}
            journalVoucher={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            api={api}
            data={{ id: idRow?.id, journalVoucher: idRow }}
          />

          <VoidModal
            showModal={showDeleteModal}
            toggleModal={deleteModal}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            api={api}
            data={{ id: idRow?.id, journalVoucher: idRow }}
          />


          <RecoverModal
            showModal={showRecoverModal}
            toggleModal={recoverModal}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            api={api}
            data={{ id: idRow?.id, journalVoucher: idRow }}
          />

          <CashTransferForm
            showModal={showModal}
            toggleModal={openModal}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            isDebit={isDebit}
            type={type}
          />
        </div>
      }


    </div>
  )
}

export default CashTransfer;
